module.exports = __webpack_public_path__ + "img/731.74650946.png";